import { render } from "./ImageStep.vue?vue&type=template&id=21077a72&scoped=true"
import script from "./ImageStep.vue?vue&type=script&lang=js"
export * from "./ImageStep.vue?vue&type=script&lang=js"

import "./ImageStep.vue?vue&type=style&index=0&id=21077a72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21077a72"

export default script